import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import find from 'lodash/find'
import get from 'lodash/get'
import * as timesheetHelper from '../../helpers/timesheet'
import { FONTS } from '../../../../constants'

export const ApproverRow = (props) => {
  const { project } = props
  // const projects = get(props, 'timesheetRequest.projects', [])
  // const projectData = timesheetHelper.findProject(project.project_id, projects)
  const approvers = timesheetHelper.createApproverList(get(props, 'timesheets.users'))
  const approver = find(approvers, { value: project.approver_id })

  return (
    <Row>
      <ManagerCol>
        <DetailApprover>{ get(approver, 'label') }</DetailApprover>
      </ManagerCol>
    </Row>
  )
}

ApproverRow.propTypes = {
  project: PropTypes.object,
}
ApproverRow.defaultProps = {
  project: {},
}

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 30%;
  margin-left: 1% !important;
  margin-right: 1% !important;
  border-bottom: 1px solid #CCCCCC;
`
const DetailApprover = styled.p`
  color: #000000;
  height: 25px;
  margin-bottom: 0px;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  overflow: hidden;
  width: 100%;
`
const LocationCol = styled.div`
  width: 35%;
  display: flex;
  flex-direction: column;
  font-size: 10px;
  margin-top: 10px;
`
const ManagerCol = styled(LocationCol)`
  width: 100%;
  margin-right: 0px;
`



// WEBPACK FOOTER //
// ./src/components/timesheet/tab-content/timesheet-status/approver-row.js